<template>
	<div class="c-list" :class="containerClasses">
		<template v-if="summary">
			<ul class="c-list__list">
				<li class="c-list__item c-list__inline">
					<div class="c-list-container--small">
						<template v-if="summaryIcon">
							<v-icon
								:name="'icon-' + summaryIcon"
								:cssModifiers="
									summaryIconColor +
										' c-list__icon c-icon--xs'
								"
							/>
						</template>
						<span class="c-list__title">
							{{ summaryItem }} och {{ advantages }} andra
							fördelar
						</span>
					</div>
				</li>
			</ul>
		</template>

		<template v-else>
			<template v-if="heading">
				<h2 class="c-footer__contact-heading">{{ heading }}</h2>
			</template>
			<ul class="c-list__list">
				<li
					class="c-list__item"
					v-for="(item, index) in listItems"
					:key="index"
				>
					<template v-if="item.href">
						<div
							v-if="item.icon"
							class="c-contact"
							style="margin-bottom: 16px;"
						>
							<div class="c-contact__icon">
								<v-icon :name="item.icon" size="s" />
							</div>
							<div class="c-contact__heading-and-text">
								<p class="c-contact__heading">
									{{ item.name }}
								</p>
								<p class="c-contact__link">
									<a
										:href="item.href"
										class="c-contact--action"
										>{{ item.linkText }}</a
									>
								</p>
							</div>
						</div>
						<div
							v-else
							v-bind:style="
								isFooter
									? 'margin-left: 32px'
									: 'margin-left: -8px'
							"
						>
							<a
								class="c-list__link no-style"
								:class="{ 'c-list__link--active': active }"
								:href="item.href"
								:target="item.target"
							>
								{{ item.name }}
							</a>
						</div>
					</template>
					<template v-else>
						<div class="c-list-container--small">
							<template v-if="item.icon">
								<v-icon
									:name="'icon-' + item.icon"
									:cssModifiers="
										item.iconColor +
											' c-list__icon c-icon--' +
											iconSize
									"
								/>
							</template>
							<span class="c-list__title">
								{{ item.name }}
							</span>
						</div>
					</template>
					<span
						v-if="item.description"
						class="c-list-title__undertext"
						>{{ item.description }}</span
					>
				</li>
			</ul>
		</template>
	</div>
</template>

<script>
import VIcon from "../../components/icon/VIcon";
export default {
	name: "VList",
	components: {
		VIcon
	},
	props: {
		heading: {
			type: String,
			default: ""
		},
		inline: {
			type: Boolean,
			default: false
		},
		summary: {
			type: Boolean,
			default: false
		},
		summaryIcon: {
			type: String,
			default: ""
		},
		summaryIconColor: {
			type: String,
			default: ""
		},
		summaryItem: {
			type: String,
			default: ""
		},
		advantages: {
			type: Number,
			default: 1
		},
		iconSize: {
			type: String,
			default: "xs"
		},
		listItems: {
			type: Array,
			default: []
		},
		itemPadding: {
			type: String,
			default: ""
		},
		fixed: {
			type: Boolean,
			default: false
		},
		isFooter: {
			type: Boolean,
			default: false
		}
	},
	data() {
		let sellingPoint = true; // This needs to be some prop or data provided.
		let containerClasses = [];
		if (this.inline) {
			containerClasses.push("c-list--inline");
		}
		if (this.fixed) {
			containerClasses.push("c-list--fixed");
		}
		if (this.itemPadding !== null && this.itemPadding !== "") {
			containerClasses.push(`c-list--${this.itemPadding}`);
		}
		return {
			containerClasses: containerClasses.join(" "),
			sellingPoint
		};
	}
};
</script>
